import { render } from "./TopToolbar.vue?vue&type=template&id=2d3a81a2"
import script from "./TopToolbar.vue?vue&type=script&lang=js"
export * from "./TopToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__